import { WhitelabelConstants } from "../constants";

const initialstate = {
  showLoading: false,
  WhitelabelRequest: false,
  WhitelabelSuccess: false,
  WhitelabelFailure: false,
  items: [],
  selectedWhitebel:'',
  response:''
};

export function whitelabel(state = initialstate, action) {
  switch (action.type) {
    case WhitelabelConstants.GETWHITELABEL_REQUEST:
      return {
        ...state,
        showLoading: true,
        WhitelabelRequest: true,
        WhitelabelFailure: false,
        WhitelabelSuccess: false,
        whitelabel: action.response,
      };
    case WhitelabelConstants.GETWHITELABEL_SUCCESS:
      return {
        ...state,
        items: action.payload,
        showLoading: false,
        WhitelabelRequest: false,
        WhitelabelFailure: false,
        WhitelabelSuccess: true,
        whitelabel: action.whitelabel,
      };
    case WhitelabelConstants.GETWHITELABEL_FAILURE:
      return {
        ...state,
        showLoading: false,
        WhitelabelRequest: false,
        WhitelabelSuccess: false,
        WhitelabelFailure: true,
        whitelabel: action.response,
      };

      case WhitelabelConstants.CREATEWHITELABEL_REQUEST:
      return {
        ...state,
        showLoading: true,
        WhitelabelRequest: true,
        WhitelabelFailure: false,
        WhitelabelSuccess: false,
        response: action.response,
        message:'',
      };
    case WhitelabelConstants.CREATEWHITELABEL_SUCCESS:
      return {
        ...state,
        response: action.response,
        showLoading: false,
        WhitelabelRequest: false,
        WhitelabelFailure: false,
        WhitelabelSuccess: true,
        
      };
    case WhitelabelConstants.CREATEWHITELABEL_FAILURE:
      return {
        ...state,
        showLoading: false,
        WhitelabelRequest: false,
        WhitelabelSuccess: false,
        WhitelabelFailure: true,
        message: action.message,
      };
    case WhitelabelConstants.SELECTED_WHITELABEL:
      return{
          ...state,
          selectedWhitebel:action.id,
          showLoading:false
      }
    case WhitelabelConstants.RESET_WHITELABEL:
      return{
        ...state,
        selectedWhitebel:'',
        showLoading:false,
        message:'',
      }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/whitelabel.reducer.js